import { request } from "@/interface/helper";

const str = "Layout";

export const Layout = {
  [`${str}`]: {
    getList: (data) => request({ data, method: "get", url: "/form/notice" }),
  },
};
